import {handleActions} from 'redux-actions'

export default function createReducer({
    MAIL_SETTINGS = {}
} = {}) {
    const initState = {
        mailSettingsSpecified: MAIL_SETTINGS.mailSettingsSpecified || false,
    }

    return handleActions({}, initState)
}



// WEBPACK FOOTER //
// ./web/js/administration/mailSettings/reducer.js